import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
    -webkit-backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
  }
`;

const slideIn = keyframes`
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) =>
    theme?.name === 'dark' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(0, 0, 0, 0.5)'};
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: ${fadeIn} 0.2s ease-out;
`;

export const ModalContainer = styled.div`
  background: ${({ theme }) =>
    theme?.name === 'dark' ? '#1F2937' : '#ffffff'};
  border-radius: 12px;
  width: 90%;
  max-width: ${(props) => props.maxWidth || '600px'};
  max-height: 90vh;
  box-shadow: ${({ theme }) =>
    theme?.name === 'dark'
      ? '0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 10px 10px -5px rgba(0, 0, 0, 0.3)'
      : '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'};
  animation: ${slideIn} 0.3s ease-out;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 95%;
    max-height: 90vh;
  }
`;

export const ModalHeader = styled.div`
  padding: 24px 24px 20px 24px;
  border-bottom: 1px solid
    ${({ theme }) => (theme?.name === 'dark' ? '#374151' : '#e5e7eb')};

  @media (max-width: 768px) {
    padding: 20px 16px 16px 16px;
  }
`;

export const ModalTitle = styled.h2`
  margin: 0 0 ${(props) => (props.hasSubtitle ? '8px' : '0')};
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) =>
    theme?.name === 'dark' ? '#F3F4F6' : theme?.colors?.blueBlack || '#0F172A'};
  padding-right: 40px;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const ModalSubtitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#9CA3AF' : '#6b7280')};
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: ${({ theme }) =>
    theme?.name === 'dark' ? '#374151' : '#f3f4f6'};
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#9CA3AF' : '#6b7280')};
  transition: all 0.2s;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background: ${({ theme }) =>
      theme?.name === 'dark' ? '#4B5563' : '#e5e7eb'};
    color: ${({ theme }) => (theme?.name === 'dark' ? '#F3F4F6' : '#374151')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;

  @media (max-width: 768px) {
    padding: 20px 16px;
  }
`;

export const ModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid
    ${({ theme }) => (theme?.name === 'dark' ? '#374151' : '#e5e7eb')};
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  @media (max-width: 768px) {
    padding: 16px;
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`;
